import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { IBatchDetails } from './../../models/generic';
import { IContractSearchData, IInvoiceBatchStatus, ITransferBatchStatus } from 'src/app/models/verification';
import { environment } from 'src/environments/environment';
import { IGenericContract, IGenericResult } from 'src/app/models/generic';
import { IFilterSearch } from 'src/app/models/filters';

@Injectable({
  providedIn: 'root'
})
export class ApiVerificationService {
  baseUrls: { [key: string]: string } = {
    //baseUrlContracts: `${environment.apis.contracts.baseUrl}/${environment.apis.contracts.microservices.contract}`,
    baseUrlContracts: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contract}`,
    //baseUrlContractReport: `${environment.apis.contracts.baseUrl}/${environment.apis.contracts.microservices.report}`,
    baseUrlContractReport: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.contractReport}`,
    //baseUrlTransfers: `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.report}`,
    baseUrlTransfers: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferReport}`,
    //baseUrlBatchTransfers: `${environment.apis.transfers.baseUrl}/${environment.apis.transfers.microservices.batch}`,
    baseUrlBatchTransfers: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.transferBatch}`,
    //baseUrlInvoicesReport: `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.report}`,
    baseUrlInvoicesReport: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceReport}`,
    //baseUrlInvoicesLots: `${environment.apis.invoices.baseUrl}/${environment.apis.invoices.microservices.batch}`,
    baseUrlInvoicesLots: `${environment.apis.unified.baseUrl}/${environment.apis.unified.microservices.invoiceBatch}`
  };

  constructor(private _http: HttpClient) { }

  //getTransfersInfo(
  //  contractNumber: string
  //): Observable<IGenericResult<ITransfersFee>> {
  //  return this._http.get<IGenericResult<ITransfersFee>>(
  //    `${this.baseUrls['baseUrlTransfers']}/contract/${contractNumber}`
  //  );
  //}

  //getInvoicesInfo(
  //  contractNumber: string
  //): Observable<IGenericResult<IInvoicesFee>> {
  //  return this._http.get<IGenericResult<IInvoicesFee>>(
  //    `${this.baseUrls['baseUrlInvoicesReport']}/contract/${contractNumber}`
  //  );
  //}

  //getTransfersAmount(): Observable<IGenericResult<ITransfersAmount>> {
  //  return this._http.post<IGenericResult<ITransfersAmount>>(
  //    `${this.baseUrls['baseUrlTransfers']}/value/transfers/contracts`,
  //    []
  //  );
  //}

  //getInvoicesAmount(): Observable<IGenericResult<IInvoicesAmount>> {
  //  return this._http.post<IGenericResult<IInvoicesAmount>>(
  //    `${this.baseUrls['baseUrlInvoicesReport']}/value/invoices/contracts`,
  //    []
  //  );
  //}

  //getTransferPassedOn(): Observable<IGenericResult<{ PassedOn: number }>> {
  //  return this._http.get<IGenericResult<{ PassedOn: number }>>(
  //    `${this.baseUrls['baseUrlBatchTransfers']}/values`
  //  );
  //}

  getAllStages(): Observable<IGenericResult<string[]>> {
    return this._http.get<IGenericResult<string[]>>(
      `${this.baseUrls['baseUrlContractReport']}/stage`
    );
  }

  getInvoiceFilterStatus(
    section: string
  ): Observable<IGenericResult<IInvoiceBatchStatus[]>> {
    return this._http.get<
      IGenericResult<IInvoiceBatchStatus[]>
    >(`${this.baseUrls['baseUrlInvoicesLots']}/status`);
  }

  getInvoiceFilterBanks(): Observable<IGenericResult<string[]>> {
    return this._http.get<IGenericResult<string[]>>(
      `${this.baseUrls['baseUrlInvoicesLots']}/banks`,
      { headers: new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) }
    );
  }

  getInvoiceFilterOperationTypes(): Observable<IGenericResult<string[]>> {
    return this._http.get<IGenericResult<string[]>>(
      `${this.baseUrls['baseUrlInvoicesLots']}/operation-types`,
      { headers: new HttpHeaders({ 'X-Skip-Error-Handler': 'true' }) }
    );
  }

  getTransferFilterStatus(
    section: string
  ): Observable<IGenericResult<ITransferBatchStatus>> {
    return this._http.get<
      IGenericResult<ITransferBatchStatus>
    >(`${this.baseUrls['baseUrlBatchTransfers']}/status`);
  }

  getContracts(
    searchData: IFilterSearch
  ): Observable<IGenericResult<IContractSearchData>> {
    return this._http.post<IGenericResult<IContractSearchData>>(
      `${this.baseUrls['baseUrlContractReport']}/stage/contract`,
      searchData
    );
  }

  getTransferContracts(
    searchData: IFilterSearch
  ): Observable<IGenericResult<IContractSearchData>> {
    return this._http.post<IGenericResult<IContractSearchData>>(
      `${this.baseUrls['baseUrlTransfers']}/stage/contract`,
      searchData
    );
  }

  getContractById(
    id: string,
    status: boolean
  ): Observable<IGenericResult<IGenericContract>> {
    return this._http.get<IGenericResult<IGenericContract>>(
      `${this.baseUrls['baseUrlContractReport']}/contract/${id}?current=${status}`
    );
  }

  getContractByNumber(
    contractNumber: string,
    queryNumber: string,
    financialInstitution: string
  ): Observable<IGenericResult<IGenericContract>> {
    return this._http.get<IGenericResult<IGenericContract>>(
      `${this.baseUrls['baseUrlContracts']}/contract/${contractNumber}/${queryNumber}/${financialInstitution}`
    );
  }

  getBatchDetailsByContract(
    contractId: string
  ): Observable<IGenericResult<IBatchDetails>> {
    return this._http.get<IGenericResult<IBatchDetails>>(
      `${this.baseUrls['baseUrlInvoicesLots']}/details/by-contract/${contractId}`
    );
  }
}
